import { useLocale } from "@obs/components";
import { createFileRoute, Navigate, Outlet, useLocation } from "@tanstack/react-router";
import { IntlProvider } from "react-intl";

import { useAccount } from "../Components/Account/AccountProvider";
import { getMessages } from "../intl/getMessages";
import type { SupportedLocale } from "../types/types";

export const Route = createFileRoute("/_authenticated")({
	component: () => <RouteComponent />,
});

function RouteComponent() {
	const { isAuthenticated, hasPasswordToReset } = useAccount();
	const location = useLocation();
	const { locale } = useLocale();

	if (hasPasswordToReset && location.pathname !== "/update-password") {
		return <IntlProvider messages={getMessages(locale as SupportedLocale)} locale={locale}><Navigate to="/update-password" replace /></IntlProvider>;
	}

	if (!isAuthenticated) {
		return (
		<IntlProvider messages={getMessages(locale as SupportedLocale)} locale={locale}>
			<Navigate to="/login" replace />
		</IntlProvider>)
	}

	return (
		<IntlProvider messages={getMessages(locale as SupportedLocale)} locale={locale}>
			<Outlet />
		</IntlProvider>
	);
}
